import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { field } from '../Input/style/default';

const wrap: CSSObject = {
  paddingBottom: 8,
};

const textarea: CSSObject = {
  ...field,
  padding: '12px 12px 32px 12px',
  resize: 'none',
  fontSize: '14px',
  lineHeight: 1.6,
  maxWidth: '100%',
  '::placeholder': {
    color: theme.color.grey300,
    fontSize: '14px',
  },
};

const maxParagraph: CSSObject = {
  textAlign: 'right',
  padding: '6px 2px',
  fontSize: '12px',
  color: theme.color.grey600,
  '> span': {
    color: theme.color.grey300,
  },
};

export { wrap, textarea, maxParagraph };
